export type Surface = 'deck' | 'workspace' | 'other';

export const WORKSPACE_SECTIONS = [
  'campaigns',
  'products',
  'studio',
  'systems',
  'inbox',
  'contacts',
  'data',
  'settings',
] as const;

export type WorkspaceSection = (typeof WORKSPACE_SECTIONS)[number];

export function getSurface(pathname: string): Surface {
  if (pathname === '/') return 'deck';
  const firstSegment = pathname.split('/')[1];
  if (WORKSPACE_SECTIONS.includes(firstSegment as WorkspaceSection)) {
    return 'workspace';
  }
  return 'other';
}

export function getWorkspaceSection(pathname: string): WorkspaceSection | null {
  const firstSegment = pathname.split('/')[1];
  return WORKSPACE_SECTIONS.includes(firstSegment as WorkspaceSection)
    ? (firstSegment as WorkspaceSection)
    : null;
}
